export const getDepositTitle = (isReplenishable: boolean, isWithdrawable: boolean) => {
  if (!isReplenishable && !isWithdrawable) {
    return "deposits.standard";
  }
  if (isReplenishable && isWithdrawable) {
    return "deposits.replenishAndWithdraw";
  }
  if (!isReplenishable && isWithdrawable) {
    return "deposits.withdraw";
  }
  if (isReplenishable && !isWithdrawable) {
    return "deposits.replenish";
  }
  return "";
};
